import ApiConstants from "../../constants/ApiConstant";
import { apiPost } from "../../services/apiService";

export const UploadMediaRequestAPI = (
  selectedFiles,
  driveName,
  isMultiple,
  callBack
) => {
  let formData = new FormData();
  if (isMultiple) {
    selectedFiles.forEach((file) => {
      formData.append("files", file); // Ensure 'file' is a File object
    });
  } else {
    formData.append("files", selectedFiles[0]); // Ensure this is a File object
  }

  formData.append("file_drive", driveName); // Make sure the drive name is correct

  return async () => {
    try {
      await apiPost(
        `${ApiConstants.fileStorageUrl}?file_drive=${driveName}`,
        formData,
        {
          "Content-Type": "multipart/form-data", // Ensure proper content type
        }
      )
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.error("Error uploading media:", err);
          callBack && callBack(false, err);
        });
    } catch (err) {
      console.error("Error in UploadMediaRequestAPI:", err);
      throw err;
    }
  };
};
